import FileSaver from 'file-saver';
import html2canvas from 'html2canvas';

interface IProps {
  node: HTMLDivElement;
  fileName: string;
  index: number;
  onError: (error: unknown, message: string) => void;
}

export const htmlToPng = async ({node, fileName, index, onError}: IProps) => {
  try {
    const canvas = await html2canvas(node, {
      useCORS: true,
      allowTaint: true,
      logging: true,
      backgroundColor: null,
    });

    canvas.style.display = 'none';
    document.body.appendChild(canvas);
    const dataUrl = canvas.toDataURL('image/png');

    FileSaver.saveAs(dataUrl, `${fileName}-${index}.png`);
    canvas.remove();
  } catch (error) {
    onError(error, 'Failed to create or download post error');
  }
};
